<template>
    <div class="panel_container" :class="{ pp_group: props.groupName === 'PP' }"
        :style="{ color: customStyles.active_font_color }">
        <van-row class="titleHead" justify="space-between">
            <van-col span="15" class="group_col">
                <img :src="props.groupImage" alt="">
                <div class="groupName">{{ $t(groupName) }}</div>
                <div class="gameCount">
                    <div>{{ gameCount }}</div>
                </div>
            </van-col>
            <van-col span="8" class="group_col_right">
                <div class="arrowBtn" @click="prevPage"><van-icon name="arrow-left" /></div>
                <div class="arrowBtn" @click="nextPage"><van-icon name="arrow" /></div>
                <div class="gameCount" @click="goToGamePannel" >{{ $t('message.all') }}</div>
            </van-col>
            <van-col span="24" class="beforeContainer">
                <div></div>
            </van-col>
        </van-row>
        <div class="gamescontainer">
            <div v-if="!isShowAllGame" class="game-slider-container">
                <transition :name="slideDirection === 'right' ? 'slide-right' : 'slide-left'">
                    <div class="page-block" :key="currentPage"> <van-grid :column-num="gameGrid.columnCount"
                            :border="false"> <van-grid-item v-for="item in paginatedGameList" :key="item.id"
                                class="grid-item">
                                <GameCard :gameImage="item.customIcon" :gameTypeId="item.id"
                                    :gameIsFavorite="item.isFavorite"
                                    @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)" />
                            </van-grid-item> </van-grid> </div>
                </transition>
            </div>
            <div v-else class="game-slider-container">
                <div class="page-block" :key="currentPage"> <van-grid :column-num="gameGrid.columnCount"
                        :border="false"> <van-grid-item v-for="item in props.gameList" :key="item.id" class="grid-item">
                            <GameCard :gameImage="item.customIcon" :gameTypeId="item.id"
                                :gameIsFavorite="item.isFavorite"
                                @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)" />
                        </van-grid-item> </van-grid> </div>
            </div>

        </div>
        
        
        <div class="showAllText">
            <div class="line"></div>
            <div v-if="!isShowAllGame && gameCount > 12" @click="showGames" style="padding: 10px;">{{
                $t('game.showAll') }}<van-icon name="arrow-down" class="showIcon" /></div>
            <div v-if="isShowAllGame && gameCount > 12" @click="showGames" style="padding: 10px;">{{
                $t('game.collect') }}<van-icon name="arrow-up" class="showIcon" /></div>
        </div>

    </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue'
import { PropType } from 'vue'
import GameCard from '../../game/components/gameCard.vue';
import { playClickSound } from '@/utils/media';
import { useRouter } from 'vue-router';
import { GameGroupData, GameList, goToPlayGame } from '@/view/home/supportScript';
const slideDirection = ref<'left' | 'right'>('right')
const gameGrid = ref({
    rowCount: 0,
    columnCount: 0
})
const customStyles = ref({
    active_font_color: '',
    border_color: ""
})
const props = defineProps({
    gameList: {
        type: Array as PropType<GameList[]>,
        required: true
    },
    groupImage: {
        type: String,
        default: ''
    },
    groupName: {
        type: String,
        default: ''
    },
    itemData: {
        type: Object as PropType<GameGroupData>,
        required: true
    },
    itemIndex: {
        type: Number,
    }

})
const router = useRouter()
const gameCount = computed(() => props.gameList.length);
const displayCount = computed(() => props.gameList.length < 12 ? props.gameList.length : 12);
const isShowAllGame = ref(false)
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const emits = defineEmits(['showGames', 'goGamePannel'])
const currentPage = ref(0)
const pageSize = computed(() => {
    return gameGrid.value.rowCount * gameGrid.value.columnCount
})

const totalPages = computed(() => {
    return Math.ceil(props.gameList.length / pageSize.value)
})

const paginatedGameList = computed(() => {
    const start = currentPage.value * pageSize.value
    return props.gameList.slice(start, start + pageSize.value)
})


const nextPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        slideDirection.value = 'right'
        currentPage.value++
    }
}

const prevPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value > 0) {
        playClickSound()
        slideDirection.value = 'left'
        currentPage.value--
    }
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: any) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const showGames = () => {
    isShowAllGame.value = !isShowAllGame.value
}
const goToGamePannel = () => {
    emits('goGamePannel')
}
onMounted(() => {
    gameGrid.value.rowCount = props.itemData.gamesGrid.rowCount
    gameGrid.value.columnCount = props.itemData.gamesGrid.columnCount
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
})
</script>
<style scoped>
.panel_container {
    padding: 0px 0px 25px;
    font-weight: 600;
    margin-top: 15px;
    border-radius: 18px;
    position: relative;
}

.bottomText {
    padding: 10px 0;
    text-align: center;
    font-weight: 500;
}

.showAllText {
    color: #fff;
    font-weight: bold;
    text-align: center;
    margin: 0 15px;
    background: rgb(2, 74, 73);
    border-radius: 10px;
    margin-top: 1px;
}

.line {
    display: flex;
    justify-content: center;
    margin: 0 7.5%;
    height: 1px;
    background: rgb(13, 176, 174);
    margin-top: 1px;
}

.showIcon {
    background: rgb(165, 160, 69);
    border-radius: 30px;
    color: rgba(0, 0, 0, 0.399);
    font-size: 10px;
    margin: 5px;
    padding: 3px;
}

.titleHead {
    background: rgb(0, 86, 85);
    min-height: 2.5rem;
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
    border-top: 0.09375rem solid rgb(245, 200, 76);

}

.group_col {
    display: flex;
    padding: 10px;
    align-items: center;
}

.groupName {
    padding-left: 10px;
    font-size: 20px;
    font-weight: 800;
}

.gameCount {
    display: flex;
    flex-direction: column;
    font-size: 18px;
    background-color: rgb(2, 74, 73);
    color: rgb(13, 176, 174);
    font-weight: 500;
    padding: 5px 15px;
    border-radius: 5px;
    margin-left: 10px;
}


.group_name {
    font-size: 15.4px;
    padding: 0 5px;
    font-weight: 700;
}

.group_col_right {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 15px;
}

.group_col img {
    width: 25px;
}

.game_list {
    display: flex;
    justify-content: left;
    padding: 5px;
}

.game_count {
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    border-radius: 5px;
    padding: 3px 8px;
}

.more_button img {
    width: 17px;
    padding-left: 5px;
}

.game-slider-container {
    position: relative;
}

.game-slider-container>>>.van-grid-item__content {
    background-color: transparent;
    display: flex;
    justify-content: left;
    padding: 5px;
}

.game-slider-container>>>.van-grid-item__content:after {
    border: none;
}

.arrow {
    position: absolute;
    top: 40%;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 10;
    border-radius: 50%;
    user-select: none;
}

.arrow.left {
    left: 0;
}

.arrow.left img {
    width: 15px;
    margin-left: -5px;
}

.arrow.right {
    right: 0;
}

.arrow.right img {
    width: 15px;
    transform: rotate(180deg);
    margin-right: -15px;
}

.bottom_text {
    color: #d1d1d1;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
}

.bottom_text img {
    width: 10px;
    background: rgba(0, 0, 0, 0.65);
    padding: 3px;
    border-radius: 30px;
    margin-left: 5px;
}

.arrowBtn {
    display: flex;
    align-items: center;
    background-color: rgb(2, 74, 73);
    padding: 8px;
    margin-right: 5px;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff89;
}

.gamescontainer {
    position: relative;
    overflow: hidden;
    background: rgb(2, 74, 73);
    margin: -20px 15px 0;
    border-radius: 0 0 10px 10px;
    padding: 10px;
}

.page-block {
    width: 100%;
    box-sizing: border-box;
    padding: 0;
}

.grid-item {
    box-sizing: border-box;
}

.slide-right-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.slide-right-enter-active {
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-right-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-right-leave-from {
    transform: translateX(0);
    opacity: 1;
}

.slide-right-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-right-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-left-enter-from {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-left-enter-active {
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-left-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-left-leave-from {
    transform: translateX(0);
    opacity: 1;
}

.slide-left-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transition: transform 360ms ease, opacity 360ms ease;
}

.slide-left-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

.beforeContainer {
    background: rgb(2, 74, 73);
    padding: 10px;
    border-radius: 0 0 10px 10px;
}

.beforeContainer div {
    background: rgb(0, 53, 52);
    padding: 7.5px;
    border-radius: 30px;
}

@media (max-width:450px) {
    .groupName {
        font-size: 15px;
    }

    .group_col {
        padding: 5px 10px;
    }

    .gameCount {
        font-size: 12px;
    }

    .group_col_right {
        padding: 10px;
    }

    .slashLine {
        width: 30px;
    }
}
</style>